import { logEvent } from './analyticsUtils';

const importAnalytics = () => {

  const ANALYTICS_EVENTS = {
    ImportStarted: 'import_file_started',
    ImportCompleted: 'import_file_complete',
    ImportDeleted: 'import_file_deleted',
    ImportFailed: 'import_file_failed',
  };

  const logImportStarted = () => {
    logEvent(ANALYTICS_EVENTS.ImportStarted);
  };

  const logImportCompleted = (featuresCount) => {
    logEvent(ANALYTICS_EVENTS.ImportCompleted,{
      featuresCount
    });
  };
  
  const logImportDeleted = () => {
    logEvent(ANALYTICS_EVENTS.ImportDeleted);
  };

  const logImportFailed = () => {
    logEvent(ANALYTICS_EVENTS.ImportFailed);
  };

  return {
    logImportStarted,
    logImportCompleted,
    logImportDeleted,
    logImportFailed,
  };
};

export default importAnalytics();